"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Page = require("@atlaskit/page").default;
const PageHeader = require("@atlaskit/page-header").default;
const { Grid, GridColumn } = require("@atlaskit/page");
const Content = styled_components_1.default.div `
  margin: 0 20px 20px 20px;
`;
const Footer = styled_components_1.default.div `
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  padding: 5px;
  background-color: white;
  z-index: 9999;
`;
const FULL_WIDTH = 12;
const MAIN_CONTENT_WIDTH = 8;
const SIDEBAR_WIDTH = 4;
class PageLayout extends React.Component {
    render() {
        const { title, side, footer, actions, children, breadcrumbs } = this.props;
        return (React.createElement(Page, null,
            React.createElement(Content, null,
                React.createElement(Grid, null,
                    React.createElement(GridColumn, { medium: FULL_WIDTH },
                        React.createElement(PageHeader, { breadcrumbs: breadcrumbs, actions: actions }, title))),
                React.createElement(Grid, null,
                    React.createElement(GridColumn, { medium: side ? MAIN_CONTENT_WIDTH : FULL_WIDTH }, children),
                    side && React.createElement(GridColumn, { medium: SIDEBAR_WIDTH }, side)),
                footer && (React.createElement(Footer, null,
                    React.createElement(Grid, null, footer))))));
    }
}
exports.PageLayout = PageLayout;
